import "../css/style.scss";

// Our modules / classes

import HeroSlider from "./modules/HeroSlider";
import Search from "./modules/Search";

const heroSlider = new HeroSlider();
const search = new Search();

import SearchDocs from "./modules/SearchDocs";
const searchDocs = new SearchDocs();

import SearchExam from "./modules/SearchExam";
const searchExam = new SearchExam();

import SearchTeacher from "./modules/SearchTeacher";
const searchTeacher = new SearchTeacher();

// Instantiate a new object using our modules/classes

//import MyNotes from "./modules/MyNotes"
//import Like from "./modules/Like"
//import GoogleMap from "./modules/GoogleMap"
//import MobileMenu from "./modules/MobileMenu"
//const mobileMenu = new MobileMenu()
//const googleMap = new GoogleMap()
//const myNotes = new MyNotes()
//const like = new Like()
